import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    preview: (warning) => ({
        background: 'none',
        border: `1px solid ${warning ? theme.colors.warning.main : theme.colors.gray[200]}`,
        borderRadius: theme.spacing(1),
        boxSizing: 'border-box',
        display: 'inline-block',
        padding: theme.spacing(1),
        margin: 0,
        width: '100%',
        outline: 0,
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        wordBreak: 'keep-all',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontStyle: 'inherit',
        fontVariantLigatures: 'inherit',
        fontWeight: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: 'inherit',
        tabSize: 'inherit',
        textIndent: 'inherit',
        textRendering: 'inherit',
        textTransform: 'inherit',
        '&:hover': {
            borderColor: theme.colors.gray[900],
        },
        '&:focus': {
            borderColor: theme.colors.primary.main,
        },
    }),
}));
//# sourceMappingURL=SyntaxColoringInput.styles.js.map